export enum CurrencyCode {
    AFN = 'AFN',
    ALL = 'ALL',
    DZD = 'DZD',
    AOA = 'AOA',
    ARS = 'ARS',
    AMD = 'AMD',
    AWG = 'AWG',
    AZN = 'AZN',
    BSD = 'BSD',
    BHD = 'BHD',
    BDT = 'BDT',
    BBD = 'BBD',
    BYN = 'BYN',
    BZD = 'BZD',
    BMD = 'BMD',
    BTN = 'BTN',
    BOB = 'BOB',
    BOV = 'BOV',
    BAM = 'BAM',
    BWP = 'BWP',
    BRL = 'BRL',
    BND = 'BND',
    BGN = 'BGN',
    BIF = 'BIF',
    CVE = 'CVE',
    KHR = 'KHR',
    CAD = 'CAD',
    KYD = 'KYD',
    CLF = 'CLF',
    CLP = 'CLP',
    CNY = 'CNY',
    COP = 'COP',
    COU = 'COU',
    KMF = 'KMF',
    CDF = 'CDF',
    CRC = 'CRC',
    HRK = 'HRK',
    CUC = 'CUC',
    CUP = 'CUP',
    CZK = 'CZK',
    DJF = 'DJF',
    DOP = 'DOP',
    EGP = 'EGP',
    SVC = 'SVC',
    ERN = 'ERN',
    ETB = 'ETB',
    FKP = 'FKP',
    FJD = 'FJD',
    XAF = 'XAF',
    GMD = 'GMD',
    GEL = 'GEL',
    GHS = 'GHS',
    GIP = 'GIP',
    DKK = 'DKK',
    GTQ = 'GTQ',
    GNF = 'GNF',
    GYD = 'GYD',
    HTG = 'HTG',
    HNL = 'HNL',
    HKD = 'HKD',
    HUF = 'HUF',
    ISK = 'ISK',
    INR = 'INR',
    IDR = 'IDR',
    XDR = 'XDR',
    IRR = 'IRR',
    IQD = 'IQD',
    ILS = 'ILS',
    JMD = 'JMD',
    JPY = 'JPY',
    JOD = 'JOD',
    KZT = 'KZT',
    KES = 'KES',
    KPW = 'KPW',
    KRW = 'KRW',
    KWD = 'KWD',
    KGS = 'KGS',
    LAK = 'LAK',
    LBP = 'LBP',
    LSL = 'LSL',
    LRD = 'LRD',
    LYD = 'LYD',
    MOP = 'MOP',
    MGA = 'MGA',
    MWK = 'MWK',
    MYR = 'MYR',
    MVR = 'MVR',
    MRO = 'MRO',
    MUR = 'MUR',
    XUA = 'XUA',
    MXN = 'MXN',
    MXV = 'MXV',
    MDL = 'MDL',
    MNT = 'MNT',
    XCD = 'XCD',
    MZN = 'MZN',
    MMK = 'MMK',
    NAD = 'NAD',
    NPR = 'NPR',
    NIO = 'NIO',
    NGN = 'NGN',
    OMR = 'OMR',
    PKR = 'PKR',
    STN = 'STN',
    SAR = 'SAR',
    RSD = 'RSD',
    SCR = 'SCR',
    SLE = 'SLE',
    SGD = 'SGD',
    ANG = 'ANG',
    XSU = 'XSU',
    SBD = 'SBD',
    SOS = 'SOS',
    ZAR = 'ZAR',
    SSP = 'SSP',
    LKR = 'LKR',
    SDG = 'SDG',
    SRD = 'SRD',
    NOK = 'NOK',
    SZL = 'SZL',
    SEK = 'SEK',
    CHE = 'CHE',
    CHF = 'CHF',
    CHW = 'CHW',
    SYP = 'SYP',
    TWD = 'TWD',
    TJS = 'TJS',
    TZS = 'TZS',
    THB = 'THB',
    XOF = 'XOF',
    NZD = 'NZD',
    TOP = 'TOP',
    TTD = 'TTD',
    TND = 'TND',
    TRY = 'TRY',
    TMT = 'TMT',
    AUD = 'AUD',
    UGX = 'UGX',
    UAH = 'UAH',
    AED = 'AED',
    GBP = 'GBP',
    USN = 'USN',
    UYI = 'UYI',
    UYU = 'UYU',
    UZS = 'UZS',
    VUV = 'VUV',
    VEF = 'VEF',
    VED = 'VED',
    VND = 'VND',
    USD = 'USD',
    XPF = 'XPF',
    MAD = 'MAD',
    YER = 'YER',
    ZMW = 'ZMW',
    ZWL = 'ZWL',
    EUR = 'EUR',
}
